<template>
  <div class="paginacao col s12 pa-0">
    <div class="col s12 m4 l3 pa-0 right-align">
      <p class="grey-text" style="line-height: 30px;">Página {{ paginaAtual }} de {{ totalPaginas }}</p>
    </div>

    <div class="col s12 m4 l6 pa-0 center">
      <ul class="pagination">
        <!-- Botão anterior -->
        <li :class="{ disabled: paginaAtual === 1 }">
          <a href="#" @click.prevent="mudarPagina(paginaAtual - 1)">
            <i class="material-icons">chevron_left</i>
          </a>
        </li>

        <!-- Páginas dinâmicas -->
        <li
          v-for="(n, index) in paginasVisiveis"
          :key="index"
          :class="{ active: n === paginaAtual, disabled: n === '...' }"
        >
          <a
            v-if="n !== '...'"
            href="#"
            @click.prevent="mudarPagina(n)"
            class="primary-text"
            style="font-weight: bold;"
          >
            {{ n }}
          </a>
          <span v-else>...</span>
        </li>

        <!-- Botão próximo -->
        <li :class="{ disabled: paginaAtual === totalPaginas }">
          <a href="#" @click.prevent="mudarPagina(paginaAtual + 1)">
            <i class="material-icons">chevron_right</i>
          </a>
        </li>
      </ul>
    </div>

    <div class="col s12 m4 l3 pa-0">
      <p class="grey-text" style="line-height: 30px;">Exibindo {{ itensVisiveis }} de {{ totalRegistros }} iten(s)</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paginacao',
  props: {
    paginaAtual: { type: Number, required: true },
    totalPaginas: { type: Number, required: true },
    totalRegistros: { type: Number, required: true },
    itensVisiveis: { type: Number, required: true }
  },
  computed: {
    paginasVisiveis() {
      const total = this.totalPaginas;
      const atual = this.paginaAtual;
      const visiveis = 5;
      const paginas = [];

      if (total <= visiveis + 4) {
        for (let i = 1; i <= total; i++) paginas.push(i);
        return paginas;
      }

      paginas.push(1);

      if (atual <= 3) {
        for (let i = 2; i <= visiveis + 1; i++) paginas.push(i);
        paginas.push('...', total);
      } else if (atual >= total - 2) {
        paginas.push('...');
        for (let i = total - visiveis; i <= total; i++) paginas.push(i);
      } else {
        paginas.push('...');
        for (let i = atual - 2; i <= atual + 2; i++) paginas.push(i);
        paginas.push('...', total);
      }

      return paginas;
    }
  },
  methods: {
    mudarPagina(novaPagina) {
      if (novaPagina >= 1 && novaPagina <= this.totalPaginas) {
        this.$emit('mudarPagina', novaPagina);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// Paginacao.vue?57013cf5